import ContactUsScreen from "@/features/menu/ContactUsScreen";

export default function ContactUs() {
    return <ContactUsScreen />;
}
